// extracted by mini-css-extract-plugin
module.exports = {"container":"logo-usage-card_container__sMUqR","title":"logo-usage-card_title__TD8_V","image":"logo-usage-card_image__8HtlH"};